import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { LanguageProvider } from './contexts/LanguageContext'
import FoldingScrollLanding from './pages/FoldingScrollLanding'
import LandingNexus from './pages/LandingNexus'
import { LandingPage } from './pages/LandingPage'
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage'
import { TermsPage } from './pages/TermsPage'
import { SecurityPage } from './pages/SecurityPage'
import { ContactPage } from './pages/ContactPage'
import { WompiCheckoutPage } from './pages/WompiCheckoutPage'
import { WompiResultPage } from './pages/WompiResultPage'
import { WhopCheckoutPage } from './pages/WhopCheckoutPage'
import { WhopResultPage } from './pages/WhopResultPage'

export default function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<FoldingScrollLanding />} />
          <Route path="/classic" element={<LandingNexus />} />
          <Route path="/protegi2" element={<LandingPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/security" element={<SecurityPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/wompi/checkout/:orderId" element={<WompiCheckoutPage />} />
          <Route path="/wompi/payment-result" element={<WompiResultPage />} />
          <Route path="/whop/checkout/:orderId" element={<WhopCheckoutPage />} />
          <Route path="/whop/payment-result" element={<WhopResultPage />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  )
}
